import React from 'react';
import { listTypes, useMatchData } from "../../utils";
import ToggleButton from "../../../shared/components/ToggleButton";
import Sponsor from "../../../shared/components/Sponsor";
import MatchPromo from "../MatchPromo";
import { useReactAppState } from "../../../shared/containers/utils";

const MatchPromoGroup = () => {
  const { t } = useReactAppState();
  const { listType, promoInfo } = useMatchData();
  if (listType !== listTypes.matches || promoInfo == null) {
    return null;
  }

  const {
    matchPromo,
    sponsorImage,
    promotionalStay,
    promotionalFly,
    promotionalRide,
    promotionalSponsor
  } = promoInfo;
  const { assetUrl } = sponsorImage || {};

  const promoSponsor = (promotionalSponsor && promotionalSponsor?.displayText && promotionalSponsor?.displayText !== "") || (promotionalSponsor?.displayText === "" && assetUrl);
  const promoStay = promotionalStay && promotionalStay?.displayText && promotionalStay?.displayText !== "";
  const promoFly = promotionalFly && promotionalFly?.displayText && promotionalFly?.displayText !== "";
  const promoRide = promotionalRide && promotionalRide?.displayText && promotionalRide?.displayText !== "";
  const noPromos = !matchPromo && !promoStay && !promoRide && !promoFly && !promoSponsor && !assetUrl;

  return (
    <div className={`mls-o-match-strip__footer ${!matchPromo ? "mls-o-match-strip__footer--no-match-promo" : ""} ${!noPromos ? "mls-o-match-strip__footer--visible-promos" : ""}`}>
      <MatchPromo />
      {
        promotionalStay || promotionalRide || promotionalFly || promotionalSponsor
          ? (
            <div className="mls-o-match-strip__sponsors">
              {
                (promoSponsor)
                  ? <Sponsor
                    hasPresBy
                    templateUrl={assetUrl}
                    url={promotionalSponsor?.url}
                    accessibleText={promotionalSponsor?.accessibleText}
                    displayText={promotionalSponsor?.displayText}
                    openInNewTab={promotionalSponsor?.openInNewTab}
                  />
                  : null
              }
              {
                promotionalStay || promotionalRide || promotionalFly
                  ? (
                    <div className="mls-o-match-strip__promo-links">
                      {
                        (promoStay)
                          ? (
                            <div className="mls-o-match-strip__promo-stay">
                              <span className="mls-o-match-strip__promo-label">{t("match_promo_hotel")}</span>
                              {(promotionalStay?.url) ? (
                                <ToggleButton
                                  target={`${promotionalStay?.openInNewTab ? "_blank" : "_self"}`}
                                  rel={`${promotionalStay?.openInNewTab ? "noopener noreferrer" : ""}`}
                                  alt={`${promotionalStay?.accessibleText ? promotionalStay?.accessibleText : ""}`}
                                  href={promotionalStay?.url}
                                  className="mls-o-match-strip__promo-link">
                                  {promotionalStay?.displayText}
                                </ToggleButton>
                              )
                                :
                                (<span className="mls-o-match-strip__promo-link">
                                  {promotionalStay?.displayText}
                                </span>)
                              }
                            </div>
                          )
                          : null
                      }
                      {
                        (promoFly)
                          ? (
                            <div className="mls-o-match-strip__promo-stay">
                              <span className="mls-o-match-strip__promo-label">{t("match_promo_fly")}</span>
                              {(promotionalFly?.url) ? (
                                <ToggleButton
                                  target={`${promotionalFly?.openInNewTab ? "_blank" : "_self"}`}
                                  rel={`${promotionalFly?.openInNewTab ? "noopener noreferrer" : ""}`}
                                  alt={`${promotionalFly?.accessibleText ? promotionalFly?.accessibleText : ""}`}
                                  href={promotionalFly?.url}
                                  className="mls-o-match-strip__promo-link">
                                  {promotionalFly?.displayText}
                                </ToggleButton>)
                                :
                                (<span className="mls-o-match-strip__promo-link">
                                  {promotionalFly?.displayText}
                                </span>)
                              }
                            </div>
                          )
                          : null
                      }
                      {
                        (promoRide)
                          ? (
                            <div className="mls-o-match-strip__promo-stay">
                              <span className="mls-o-match-strip__promo-label">{t("match_promo_travel")}</span>
                              {(promotionalRide?.url) ? (
                                <ToggleButton
                                  target={`${promotionalRide?.openInNewTab ? "_blank" : "_self"}`}
                                  rel={`${promotionalRide?.openInNewTab ? "noopener noreferrer" : ""}`}
                                  alt={`${promotionalRide?.accessibleText ? promotionalRide?.accessibleText : ""}`}
                                  href={promotionalRide?.url}
                                  className="mls-o-match-strip__promo-link">
                                  {promotionalRide?.displayText}
                                </ToggleButton>)
                                :
                                (<span className="mls-o-match-strip__promo-link">
                                  {promotionalRide?.displayText}
                                </span>)
                              }
                            </div>
                          )
                          : null
                      }
                    </div>
                  )
                  : null
              }
            </div>
          ) : null
      }
    </div>
  );
};

export default MatchPromoGroup;
